module.exports = __webpack_public_path__ + "src/img/normalIcon.34108b1a.svg";